import type { Lead } from '@up2stay/up2promo-api-client';
import { formatLeadDisplayName } from '@up2stay/up2promo-commons';

import { LEAD_STATUS_IDS } from '@/core/components/leads/lead-status-colors';

/** Board item shape (same idea as KanbanItemProps, local to avoid coupling to kanban.tsx) */
export type LeadBoardItem = {
  id: string;
  name: string;
  column: string;
};

export function leadsToBoardData(leads: Lead[]): LeadBoardItem[] {
  return leads.map((lead) => ({
    id: lead.id,
    name:
      formatLeadDisplayName(lead.firstName, lead.lastName) ||
      lead.email ||
      lead.id,
    column: lead.status,
  }));
}

export function buildIdsByStatus(data: LeadBoardItem[]) {
  const idsByStatus = new Map<string, string[]>();
  for (const statusId of LEAD_STATUS_IDS) {
    idsByStatus.set(statusId, []);
  }
  for (const item of data) {
    if (!idsByStatus.has(item.column)) {
      idsByStatus.set(item.column, []);
    }
    idsByStatus.get(item.column)?.push(item.id);
  }
  return idsByStatus;
}

export function isSameBoardLayout(a: LeadBoardItem[], b: LeadBoardItem[]) {
  if (a.length !== b.length) return false;
  const aBy = buildIdsByStatus(a);
  const bBy = buildIdsByStatus(b);
  const keys = new Set<string>([...aBy.keys(), ...bBy.keys()]);
  for (const k of keys) {
    const aa = aBy.get(k) ?? [];
    const bb = bBy.get(k) ?? [];
    if (aa.length !== bb.length) return false;
    for (let i = 0; i < aa.length; i++) {
      if (aa[i] !== bb[i]) return false;
    }
  }
  return true;
}
